import MoreVertIcon from '@mui/icons-material/MoreVert'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import { LoadingButton } from '@mui/lab'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, Grid, IconButton,
  TextField,
  Typography
} from '@mui/material'
import I18n from 'i18n-js'
import { useContext, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom/'
import { Loader, SnackBar } from '../../../../components'
import BaseMenu from '../../../../components/baseMenu'
import { AuthContext } from '../../../../context/auth'
import patients from '../../../../services/patients'
import useStyles from '../../../../styles'
import { actionKeys, Icons, pagesKeys } from '../../../../utils'
import { isEmail } from '../../../../validators/validator'
import { canAccess } from './../../../../router/permissions'
import { downloadsEnum } from './constants/enums'
import { usePatientReports } from './hooks/endpoints'
import { useStylesSmartPredict } from './styles'

function DialogPdf(props) {
  //state
  const { state } = useContext(AuthContext)
  const { id } = useParams()
  const { styles } = useStylesSmartPredict()
  const pageId = pagesKeys.patients
  //information
  const classes = useStyles()
  const [isLooadingDialog, setIsLoadingDialog] = useState(false)
  const [hdmLoading, setHdmLoading] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [emails, setEmails] = useState()
  //snackBar
  const [anchorEl, setAnchorEl] = useState(null);
  const { getMedicalReport, getPatientReport, loadings, setSnackBar, snackBar, handleSnackBar, showSnackBar, setShowSnackBar } = usePatientReports()
  const { canDownloadReport } = props
  const sizes = { xs: 12, sm: 6 }

  const handleClickOpenDialog = () => {
    setOpenDialog(true)
  }

  const seeDocument = async (url) => {
    if (url) {
      window.open(url)
      return
    }
    setHdmLoading(true)
    const response = await patients.getHDM({
      id, body: {
        actual: props.isActualSP,
        smart_predict_id: props.historyId
      }
    })
    setShowSnackBar(true)
    setHdmLoading(false)
    if (!response.data) {
      setSnackBar({
        text: I18n.t('patient.detail.hdm.error'),
        severity: 'warning',
      })
      return
    }
    if (response.data?.ihe_xdm_url) {
      window.open(response.data?.ihe_xdm_url)
    }
    setSnackBar({
      text: I18n.t('patient.detail.hdm.success'),
      severity: 'success',
    })
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
    setEmails(undefined)
  }

  const handleSendEmail = async (e) => {
    e.preventDefault()
    setIsLoadingDialog(true)
    const body = {
      email: [emails],
      is_actual: props.isActualSP,
      history_id: props.historyId,
    }
    const response = await patients.sendEmail(props.patientId, body)
    if (response.data) {
      setIsLoadingDialog(false)
      setSnackBar({
        text: I18n.t('patient.detail.pdf.success'),
        severity: 'success',
      })
      setShowSnackBar(true)
      handleCloseDialog()
    } else {
      setIsLoadingDialog(false)
      setSnackBar({
        text: I18n.t('patient.detail.pdf.errorSend'),
        severity: 'warning',
      })
      setShowSnackBar(true)
      handleCloseDialog()
    }
  }

  const handleDownloadSelected = (payload) => {
    switch (payload.id) {
      case downloadsEnum.SMART_PREDICT: {
        props.downloadData(props.patientId, props.dateTug)
        break
      }
      case downloadsEnum.MEDICAL: {
        getMedicalReport({ patientId: props.patientId })
        break
      }
      case downloadsEnum.PATIENT: {
        getPatientReport({ patientId: props.patientId })
        break
      }
    }
  }

  const items = useMemo(() => {
    if (!canDownloadReport) {
      return [
        { id: downloadsEnum.SMART_PREDICT, label: I18n.t('general.dataDowload') },
      ]
    }
    return [
      { id: downloadsEnum.PATIENT, label: I18n.t('general.patient_report') },
      { id: downloadsEnum.MEDICAL, label: I18n.t('general.doctor_report') },
      { id: downloadsEnum.SMART_PREDICT, label: I18n.t('general.dataDowload') },
    ]
  }, [])

  function renderBody() {
    return (
      <Grid item md={6} xs={12}>
        <Box sx={styles.container}>
          <Grid container spacing={1} justifyContent={"flex-end"}>
            <Grid item {...sizes}>
              {canAccess(actionKeys.sendReport, pageId, state) && props.url && (
                <Button
                  sx={styles.btn}
                  variant="contained"
                  color="primary"
                  size="small"
                  padding="8px 15px"
                  borderRadius={4}
                  onClick={handleClickOpenDialog}
                  startIcon={<PictureAsPdfIcon />}
                >
                  {I18n.t('patient.detail.tabSmartPredict.pdf.smartPredictReport')}
                </Button>
              )}
            </Grid>

            <Grid item {...sizes}>
              <Box sx={styles.xdm}>
                <LoadingButton
                  loading={hdmLoading}
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={Icons('download')}
                  padding="8px 15px"
                  onClick={() => seeDocument(props.download)}
                  sx={styles.btn}
                >
                  {I18n.t('patient.detail.tabSmartPredict.pdf.IheXdmReport')}
                </LoadingButton>
              </Box>
            </Grid>
          </Grid>

          <IconButton onClick={(e) => { setAnchorEl(e.currentTarget) }} aria-label="menu">
            <MoreVertIcon width={60} />
          </IconButton>

          <BaseMenu
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            menuItems={items}
            click={handleDownloadSelected}
            oncesYouClickDoNotCloseIt
            loading={{
              ...loadings,
              [downloadsEnum.SMART_PREDICT]: props.loadingDownload,
            }}
          />

          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            fullWidth={true}
            maxWidth={'sm'}
            aria-labelledby="form-dialog-title"
            className={classes.dialogContainer}
          >
            {isLooadingDialog ? (
              <Loader />
            ) : (
              <form onSubmit={handleSendEmail}>
                <DialogTitle id="form-dialog-title">
                  {I18n.t('patient.detail.tabSmartPredict.pdf.documentOption')}
                </DialogTitle>
                <DialogContent>
                  <Box className={classes.btnContainer}>
                    <IconButton
                      onClick={() => seeDocument(props.url)}
                      className={classes.pdf}
                    >
                      {Icons('file-pdf')}
                      <Typography className={classes.pdfText}>
                        {I18n.t('patient.detail.tabSmartPredict.pdf.downloadPdf')}
                      </Typography>
                    </IconButton>
                  </Box>
                  <DialogContentText>
                    {I18n.t('patient.detail.pdf.description')}
                  </DialogContentText>
                  <TextField
                    value={emails || ''}
                    autoFocus
                    margin="dense"
                    id="emails"
                    name="emails"
                    // size="small"
                    error={emails != undefined ? isEmail(emails) : false}
                    label={`${I18n.t('patient.form.email')}`}
                    type="email"
                    fullWidth
                    onChange={(event) => {
                      setEmails(event.target.value)
                    }}
                  />
                  <Box style={{ minHeight: 0, height: 5 }}>
                    {emails != undefined && isEmail(emails) ? (
                      <Typography color="error" variant="caption">
                        {I18n.t('validators.invalidEmail')}
                      </Typography>
                    ) : (
                      ''
                    )}
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="text"
                    padding="15px"
                    onClick={handleCloseDialog}
                    color="primary"
                  >
                    {I18n.t('components.cancel')}
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={emails ? isEmail(emails) : true}
                  >
                    {I18n.t('components.send')}
                  </Button>
                </DialogActions>
              </form>
            )}
          </Dialog>

          <SnackBar
            text={snackBar.text}
            severity={snackBar.severity}
            show={showSnackBar}
            HandleShow={handleSnackBar}
            time={3000}
          />
        </Box>
      </Grid>
    )
  }

  return renderBody()
}

export default DialogPdf
